// SPIN (§13.4): E♭ mixolydian, 120 BPM, washing-machine shuffle (8th-note swing 0.3). Boogie bass
// on the swung 8ths (R–3–5–6–♭7–6–5–3), clavinet skanks on the 'ands', a slide-whistle-ish lead,
// a 16th shaker and a backbeat with swung ghost notes. A: I7–IV7 vamp, ♭VII–IV–I cadence;
// B: a 16-bar-blues lift through v7.
import type { SongDef } from '../songTypes';

export const SPIN: SongDef = {
  id: 'spin',
  rootMidi: 63,
  scale: 'mixolydian',
  swing: 0.3,
  swingUnit: 8,
  bars: 16,
  chords: [
    'I7', 'IV7', 'I7', 'IV7', 'I7', 'VII', 'IV', 'I7',
    'IV7', 'IV7', 'I7', 'I7', 'v7', 'IV7', 'I7', 'VII',
  ],
  drums: { kick: 'x.....x.x.......', snare: '....x.o.....x.o.', hat: 'X.x.X.x.X.x.X.x.', perc: 'xoxoxoxoxoxoxoxo' },
  drumsB: { kick: 'x.....x.x.....x.', snare: '....x.o.....x.oo', hat: 'X.x.X.x.X.x.X.x.', perc: 'xoxoxoxoxoxoxoxo' },
  fill: { kick: 'x.....x.x.......', snare: '....x.o.x.o.x.XX', hat: 'X.x.X.x.........', perc: 'xoxoxoxo........' },
  pickup: { kick: '........x.......', snare: '........x.o.x.XX', hat: 'x.x.x.x.x.x.x.x.' },
  bass: [
    'Eb2 - G2 - Bb2 - C3 - Db3 - C3 - Bb2 - G2 -',
    'Ab1 - C2 - Eb2 - F2 - Gb2 - F2 - Eb2 - C2 -',
    'Eb2 - G2 - Bb2 - C3 - Db3 - C3 - Bb2 - G2 -',
    'Ab1 - C2 - Eb2 - F2 - Gb2 - F2 - Eb2 - C2 -',
    'Eb2 - Eb2 - G2 - Bb2 - Db3 - C3 - Bb2 - F2 -',
    'Db2 - F2 - Ab2 - Bb2 - Ab2 - F2 - Db2 - Eb2 -',
    'Ab1 - C2 - Eb2 - F2 - Eb2 - C2 - Ab1 - Bb1 -',
    'Eb2 - G2 - Bb2 - C3 - Db3 - C3 - Bb2 - G2 -',
    'Ab1 - C2 - Eb2 - F2 - Gb2 - F2 - Eb2 - C2 -',
    'Ab1 - C2 - Eb2 - F2 - Gb2 - F2 - Eb2 - Bb1 -',
    'Eb2 - G2 - Bb2 - C3 - Db3 - C3 - Bb2 - G2 -',
    'Eb2 - G2 - Bb2 - C3 - Db3 - C3 - Bb2 - Ab2 -',
    'Bb1 - Db2 - F2 - Ab2 - Bb2 - Ab2 - F2 - Db2 -',
    'Ab1 - C2 - Eb2 - F2 - Gb2 - F2 - Eb2 - C2 -',
    'Eb2 - G2 - Bb2 - C3 - Db3 - C3 - Bb2 - G2 -',
    'Db2 - F2 - Ab2 - Bb2 - Ab2 - F2 - Db2 - D2 -',
  ],
  lead: [
    'G5 - - - Bb5 - - - G5 - Eb5 - - - - -',
    'Gb5 - - - Eb5 - - - C5 - - - - - - -',
    'G5 - - - Bb5 - - - Db6 - - - C6 - Bb5 -',
    'C6 - - - - - Ab5 - - - F5 - Eb5 - - -',
    'Eb5 - G5 - Bb5 - Eb6 - - - Db6 - Bb5 - - -',
    'Ab5 - - - F5 - - - Db5 - - - F5 - - -',
    'Eb5 - - - C5 - - - Ab4 - - - Bb4 - C5 -',
    'Eb5 - - - - - - - . . . . . . . .',
    'C6 - - - Eb6 - - - C6 - - - Ab5 - - -',
    'Gb5 - - - - - F5 - Eb5 - - - C5 - - -',
    'Bb5 - - - G5 - - - Eb5 - - - G5 - - -',
    'Db6 - - - C6 - - - Bb5 - - - G5 - - -',
    'F5 - - - Ab5 - - - Bb5 - - - Db6 - - -',
    'C6 - - - - - Bb5 - Ab5 - - - Eb5 - - -',
    'G5 - - - Bb5 - - - G5 - - - Eb5 - - -',
    'F5 - - - Ab5 - - - F5 - - - Eb5 - - -',
  ],
  arp: '1 . 5 . 8 . 10 . 12 . 10 . 8 . 5 .',
  comp: '..x-..x-..x-..x-',
  compB: 'x-.x..x-..x-.x..',
  voicing: 'close',
  chordRange: [58, 75],
  instruments: { bass: 'synthBass', chords: 'clav', lead: 'whistle', arp: 'bell', perc: 'shaker' },
  kit: { kick: 'kick', snare: 'snare', hat: 'hat', hatOpen: 'hatOpen', crash: 'slosh' },
  stabs: 'X.....x.........',
  mix: { hat: -6, perc: -6, arp: -8 },
};
